<template>
  <!-- print-root: solo esto se imprime -->
  <div class="page-content almacen-page print-root">
    <div class="almacen-wrapper">
      <div class="almacen-card">
        <!-- Barra superior: solo pantalla -->
        <header class="entrada-header no-print">
          <div>
            <p class="almacen-title">
              Detalle de orden de entrega
            </p>
            <p class="almacen-subtitle">
              Formato compacto y listo para impresión.
            </p>
          </div>

          <div class="entrada-header__actions">
            <button
              type="button"
              class="ios-ghost-button"
              @click="volverListado"
            >
              ← Volver al listado
            </button>
            <button
              type="button"
              class="ios-primary-button"
              @click="imprimir"
            >
              🖨 Imprimir
            </button>
          </div>
        </header>

        <section v-if="cargando" class="entrada-hint">
          Cargando orden de entrega...
        </section>

        <section v-else-if="!orden" class="entrada-hint">
          No se encontró la orden de entrega.
        </section>

        <section v-else class="orden-detalle">
          <!-- Banner de solicitud de ajuste -->
          <div
            v-if="orden.status === 'solicitando_ajuste'"
            class="ajuste-banner no-print"
          >
            <div class="ajuste-banner-body">
              <div class="ajuste-banner-title">
                Solicitud de ajuste pendiente
              </div>
              <div class="ajuste-banner-text">
                {{ orden.motivo_ajuste || 'Sin motivo registrado.' }}
              </div>
            </div>
            <div class="ajuste-banner-actions">
                <button
                type="button"
                class="ios-ghost-button ajuste-btn-mini"
                @click="aprobarAjuste"
                >
                ✅ Aprobar
                </button>
                <button
                type="button"
                class="ios-ghost-button ajuste-btn-mini"
                @click="rechazarAjuste"
                >
                ❌ Rechazar
                </button>
            </div>
          </div>

          <!-- Barra de acciones cuando está en proceso -->
          <div
            v-if="orden.status === 'en_proceso'"
            class="orden-acciones-bar no-print"
          >
            <div class="orden-acciones-info">
              Esta orden está en proceso. Marca las unidades que se entregan
              y procede al flujo de firmas, o solicita un ajuste antes de firmar.
            </div>
            <div class="orden-acciones-buttons">
              <button
                type="button"
                class="ios-ghost-button"
                @click="toggleFormularioAjuste"
              >
                ✏ Solicitar ajuste
              </button>
              <button
                type="button"
                class="ios-primary-button"
                :disabled="!puedeProcederFirmas"
                @click="iniciarFlujoFirmas"
              >
                ✍ Proceder a firmar
              </button>
            </div>
          </div>

          <!-- Formulario solicitud de ajuste -->
          <div
            v-if="orden.status === 'en_proceso' && mostrandoFormularioAjuste"
            class="ajuste-panel no-print"
          >
            <div class="ajuste-panel-header">
              <span class="orden-header-label">Motivo de ajuste</span>
              <button
                type="button"
                class="ajuste-panel-close"
                @click="cancelarFormularioAjuste"
              >
                ✕
              </button>
            </div>
            <textarea
              v-model.trim="motivoAjuste"
              class="ajuste-textarea"
              rows="3"
              placeholder="Describe qué está incorrecto en esta orden..."
            ></textarea>
            <div class="ajuste-panel-actions">
              <button
                type="button"
                class="ios-ghost-button"
                @click="cancelarFormularioAjuste"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="ios-primary-button"
                :disabled="!motivoAjuste || enviandoAjuste"
                @click="enviarSolicitudAjuste"
              >
                {{ enviandoAjuste ? 'Enviando...' : 'Enviar solicitud de ajuste' }}
              </button>
            </div>
          </div>

          <!-- Encabezado tipo ficha -->
          <div class="orden-header-simple">
            <div class="orden-header-col">
              <div class="orden-header-row">
                <span class="orden-header-label">Orden de entrega</span>
                <span class="orden-header-value orden-header-strong">
                  {{ formatoFolio(orden.folio, orden.version || 1) }}
                </span>
              </div>
              <div class="orden-header-row">
                <span class="orden-header-label">Token</span>
                <span class="orden-header-value">
                  {{ orden.token_orden }}
                </span>
              </div>
              <div class="orden-header-row">
                <span class="orden-header-label">Fecha programada</span>
                <span class="orden-header-value">
                  {{ formatearFecha(orden.fecha_programada) }}
                </span>
              </div>
              <div class="orden-header-row">
                <span class="orden-header-label">Creada</span>
                <span class="orden-header-value">
                  {{ formatearFechaHora(orden.creado) }}
                </span>
              </div>
            </div>

            <div class="orden-header-col">
              <div class="orden-header-row">
                <span class="orden-header-label">Centro</span>
                <span class="orden-header-value">
                  {{ orden.centro_nombre || '—' }}
                </span>
              </div>
              <div class="orden-header-row">
                <span class="orden-header-label">Dirección</span>
                <span class="orden-header-value">
                  {{ orden.centro_direccion || '—' }}
                </span>
              </div>
              <div class="orden-header-row">
                <span class="orden-header-label">Ciudad / Estado</span>
                <span class="orden-header-value">
                  {{ orden.centro_ciudad || '' }}
                  <span v-if="orden.centro_estado">, {{ orden.centro_estado }}</span>
                </span>
              </div>
              <div class="orden-header-row">
                <span class="orden-header-label">Estatus</span>
                <span class="orden-header-value">
                  {{ etiquetaStatus(orden.status) }}
                </span>
              </div>
            </div>

            <div class="orden-header-col">
              <div class="orden-header-row">
                <span class="orden-header-label">Contacto</span>
                <span class="orden-header-value">
                  {{ orden.contacto_nombre || '—' }}
                </span>
              </div>
              <div class="orden-header-row">
                <span class="orden-header-label">Teléfono</span>
                <span class="orden-header-value">
                  {{ orden.contacto_telefono || '—' }}
                </span>
              </div>
              <div class="orden-header-row">
                <span class="orden-header-label">Correo</span>
                <span class="orden-header-value">
                  {{ orden.contacto_email || '—' }}
                </span>
              </div>
            </div>
          </div>

          <!-- Observaciones -->
          <div
            v-if="orden.observaciones"
            class="orden-comentarios-simple"
          >
            <span class="orden-header-label">Observaciones</span>
            <p class="orden-header-value">
              {{ orden.observaciones }}
            </p>
          </div>

          <!-- Tabla de unidades -->
          <div class="orden-items-table">
            <table>
              <thead>
                <tr>
                  <!-- Col de selección solo en proceso (y no en impresión) -->
                  <th
                    v-if="orden.status === 'en_proceso'"
                    class="no-print"
                    style="width: 50px;"
                  >
                    Sel.
                  </th>
                  <th style="width: 50px;">Grupo</th>
                  <th style="width: 80px;">Tipo</th>
                  <th>Producto</th>
                  <th style="width: 170px;">Número de serie</th>
                  <th style="width: 80px;" class="no-print">Entregado</th>
                  <th style="width: 80px;" class="no-print">Devuelto</th>
                  <th>Observaciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!orden.detalles || !orden.detalles.length">
                  <td
                    :colspan="colspanTabla"
                    class="orden-items-table-empty"
                  >
                    No se registraron unidades en esta orden.
                  </td>
                </tr>
                <tr
                  v-else
                  v-for="d in orden.detalles"
                  :key="d.id_detalle"
                >
                  <!-- Checkbox selección sólo en proceso -->
                  <td
                    v-if="orden.status === 'en_proceso'"
                    class="orden-items-table-center no-print"
                  >
                    <input
                      type="checkbox"
                      class="orden-checkbox"
                      :checked="!!d._seleccionado"
                      :disabled="bloquearSeleccion"
                      @change="toggleSeleccionDetalle(d)"
                    />
                  </td>
                  <td class="orden-items-table-center">
                    {{ d.grupo_unidad || '—' }}
                  </td>
                  <td>
                    {{ d.tipo_unidad === 'complemento' ? 'Complemento' : 'Principal' }}
                  </td>
                  <td>
                    {{ d.producto_nombre }}
                  </td>
                  <td>
                    {{ d.numero_serie || '—' }}
                  </td>
                  <td class="orden-items-table-center no-print">
                    {{ esEntregado(d) ? 'Sí' : 'No' }}
                  </td>
                  <td class="orden-items-table-center no-print">
                    {{ esDevuelto(d) ? 'Sí' : 'No' }}
                  </td>
                  <td>
                    {{ d.observaciones || '' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <section
            v-if="orden && orden.detalles && orden.detalles.length"
            class="orden-evidencias-panel no-print"
          >
            <div class="orden-evidencias-panel__head">
              <div>
                <h3>Evidencia de estado por unidad</h3>
                <p>
                  Opcional. Puedes registrar la evidencia al momento de la salida o volver después a esta orden para actualizarla.
                </p>
              </div>
            </div>

            <div class="orden-evidencias-grid">
              <article
                v-for="d in orden.detalles"
                :key="'ev-' + d.id_detalle"
                class="orden-evidencia-card"
              >
                <div class="orden-evidencia-card__top">
                  <div>
                    <div class="orden-evidencia-card__title">{{ d.producto_nombre }}</div>
                    <div class="orden-evidencia-card__meta">
                      Serie: {{ d.numero_serie || '—' }} ·
                      {{ d.tipo_unidad === 'complemento' ? 'Complemento' : 'Principal' }}
                    </div>
                  </div>
                  <button
                    type="button"
                    class="ios-ghost-button evidencia-btn-mini"
                    @click="toggleEvidenciaDetalle(d)"
                  >
                    {{ d._evidencia_abierta ? 'Ocultar' : 'Actualizar evidencia' }}
                  </button>
                </div>

                <div class="orden-evidencia-actual">
                  <div class="orden-evidencia-actual__media" v-if="d.imagen_estado_url || d.imagen_principal_url || d._evidencia_preview">
                    <img
                      :src="d._evidencia_preview || d.imagen_estado_url || d.imagen_principal_url"
                      alt="Evidencia de estado"
                    />
                  </div>
                  <div class="orden-evidencia-actual__body">
                    <div class="orden-evidencia-chip-row">
                      <span class="orden-evidencia-chip" v-if="d.imagen_estado_url">Foto actual</span>
                      <span class="orden-evidencia-chip orden-evidencia-chip--soft" v-else-if="d.imagen_principal_url">Imagen base producto</span>
                      <span class="orden-evidencia-chip orden-evidencia-chip--muted" v-else>Sin foto</span>
                    </div>
                    <p class="orden-evidencia-actual__text">
                      {{ d.descripcion_estado || 'Sin descripción de estado registrada todavía.' }}
                    </p>
                  </div>
                </div>

                <div v-if="d._evidencia_abierta" class="orden-evidencia-form">
                  <textarea
                    v-model.trim="d._evidencia_descripcion"
                    class="ajuste-textarea"
                    rows="3"
                    placeholder="Describe el estado físico con el que salió esta unidad..."
                  ></textarea>
                  <textarea
                    v-model.trim="d._evidencia_observaciones"
                    class="ajuste-textarea ajuste-textarea--small"
                    rows="2"
                    placeholder="Observaciones internas opcionales de esta evidencia..."
                  ></textarea>

                  <div class="orden-evidencia-form__file-row">
                    <input
                      :ref="'inputEvidenciaEntrega_' + d.id_detalle"
                      type="file"
                      accept="image/png,image/jpeg,image/webp"
                      class="orden-evidencia-input-file"
                      @change="onEvidenciaSeleccionada(d, $event)"
                    >
                    <button
                      type="button"
                      class="ios-ghost-button evidencia-btn-mini"
                      @click="limpiarArchivoEvidencia(d)"
                    >
                      Limpiar foto nueva
                    </button>
                  </div>

                  <div v-if="d._evidencia_preview" class="orden-evidencia-preview">
                    <img :src="d._evidencia_preview" alt="Vista previa de evidencia" />
                  </div>

                  <div class="ajuste-panel-actions">
                    <button
                      type="button"
                      class="ios-ghost-button"
                      @click="cancelarEvidenciaDetalle(d)"
                    >
                      Cancelar
                    </button>
                    <button
                      type="button"
                      class="ios-primary-button"
                      :disabled="guardandoEvidenciaId === d.id_detalle"
                      @click="guardarEvidenciaDetalle(d)"
                    >
                      {{ guardandoEvidenciaId === d.id_detalle ? 'Guardando...' : 'Guardar evidencia de salida' }}
                    </button>
                  </div>
                </div>
              </article>
            </div>
          </section>

            <!-- Firmas (visual: muestra la imagen si existe, o la línea base) -->
          <div class="orden-firmas">
            <div class="orden-firma-col">
                <div v-if="firmaEntregaSrc" class="orden-firma-img-wrapper">
                <img
                    :src="firmaEntregaSrc"
                    alt="Firma de entrega"
                    class="orden-firma-img"
                />
                </div>
                <div v-else class="orden-firma-linea"></div>
                <div class="orden-firma-label">
                Firma de entrega / empresa
                <span v-if="orden && orden.nombre_entrega" class="orden-firma-label-name">
                  {{ orden.nombre_entrega }}
                </span>
                </div>
            </div>

            <div class="orden-firma-col">
                <div v-if="firmaRecepcionSrc" class="orden-firma-img-wrapper">
                <img
                    :src="firmaRecepcionSrc"
                    alt="Firma de recepción"
                    class="orden-firma-img"
                />
                </div>
                <div v-else class="orden-firma-linea"></div>
                <div class="orden-firma-label">
                Firma de recepción / centro
                <span v-if="orden && orden.nombre_recepcion" class="orden-firma-label-name">
                  {{ orden.nombre_recepcion }}
                </span>
                </div>
            </div>
          </div>

        </section>
      </div>
    </div>

    <!-- MODAL FLUJO DE FIRMAS -->
    <div
      v-if="mostrandoModalFirmas"
      class="modal-overlay no-print"
    >
      <div class="modal-card">
        <!-- Encabezado + contenido variable por paso -->
        <template v-if="pasoFirma === 1">
          <h2 class="modal-title">Firma de entrega</h2>
          <p class="modal-text">
            Persona que entrega en nombre de la empresa. Firma usando mouse o touch.
          </p>
        </template>

        <template v-else-if="pasoFirma === 2">
          <h2 class="modal-title">Resumen y firma de recepción</h2>
          <p class="modal-text">
            Verifica las unidades seleccionadas y firma la persona que las recibe.
          </p>

          <div class="resumen-tabla">
            <table>
              <thead>
                <tr>
                  <th>Grupo</th>
                  <th>Tipo</th>
                  <th>Producto</th>
                  <th>Número de serie</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="d in resumenSeleccion"
                  :key="d.id_detalle"
                >
                  <td>{{ d.grupo_unidad || '—' }}</td>
                  <td>{{ d.tipo_unidad === 'complemento' ? 'Complemento' : 'Principal' }}</td>
                  <td>{{ d.producto_nombre }}</td>
                  <td>{{ d.numero_serie || '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>

        <!-- Canvas de entrega: siempre montado, solo se muestra en paso 1 -->
        <div
          v-show="pasoFirma === 1"
          class="firma-wrapper"
        >
          <canvas
            ref="canvasEntrega"
            class="firma-canvas"
            width="600"
            height="180"
            @mousedown="inicioDibujo('entrega', $event)"
            @mousemove="dibujar('entrega', $event)"
            @mouseup="finDibujo('entrega')"
            @mouseleave="finDibujo('entrega')"
            @touchstart.prevent="inicioDibujo('entrega', $event)"
            @touchmove.prevent="dibujar('entrega', $event)"
            @touchend.prevent="finDibujo('entrega')"
            @touchcancel.prevent="finDibujo('entrega')"
          ></canvas>
        </div>

        <!-- Canvas de recepción: siempre montado, solo se muestra en paso 2 -->
        <div
          v-show="pasoFirma === 2"
          class="firma-wrapper firma-wrapper--top"
        >
          <span class="orden-header-label">Firma de recepción</span>
          <canvas
            ref="canvasRecepcion"
            class="firma-canvas"
            width="600"
            height="180"
            @mousedown="inicioDibujo('recepcion', $event)"
            @mousemove="dibujar('recepcion', $event)"
            @mouseup="finDibujo('recepcion')"
            @mouseleave="finDibujo('recepcion')"
            @touchstart.prevent="inicioDibujo('recepcion', $event)"
            @touchmove.prevent="dibujar('recepcion', $event)"
            @touchend.prevent="finDibujo('recepcion')"
            @touchcancel.prevent="finDibujo('recepcion')"
          ></canvas>
        </div>

        <!-- Acciones paso 1 -->
        <div
          v-if="pasoFirma === 1"
          class="modal-actions"
        >
          <button
            type="button"
            class="ios-ghost-button"
            @click="limpiarFirma('entrega')"
          >
            Limpiar
          </button>
          <div class="modal-actions-right">
            <button
              type="button"
              class="ios-ghost-button"
              @click="cancelarFlujoFirmas"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="ios-primary-button"
              :disabled="firmaEntregaVacia"
              @click="irAPasoRecepcion"
            >
              Siguiente
            </button>
          </div>
        </div>

        <!-- Acciones paso 2 -->
        <div
          v-else-if="pasoFirma === 2"
          class="modal-actions"
        >
          <button
            type="button"
            class="ios-ghost-button"
            @click="limpiarFirma('recepcion')"
          >
            Limpiar firma
          </button>
          <div class="modal-actions-right">
            <button
              type="button"
              class="ios-ghost-button"
              @click="pasoFirma = 1"
            >
              ← Volver
            </button>
            <button
              type="button"
              class="ios-primary-button"
              :disabled="firmaRecepcionVacia || enviandoFirmas"
              @click="confirmarFirmas"
            >
              {{ enviandoFirmas ? 'Guardando...' : 'Confirmar entrega' }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';


export default {
  name: 'VerOrdenEntrega',
  data() {
    return {
      orden: null,
      cargando: false,

      // Ajuste
      mostrandoFormularioAjuste: false,
      motivoAjuste: '',
      enviandoAjuste: false,

      // Selección de detalles
      bloquearSeleccion: false,

      // Modal firmas
      mostrandoModalFirmas: false,
      pasoFirma: 1,
      resumenSeleccion: [],

      // Firma entrega
      firmaEntregaDibujando: false,
      firmaEntregaUltimoPunto: null,
      firmaEntregaVacia: true,

      // Firma recepción
      firmaRecepcionDibujando: false,
      firmaRecepcionUltimoPunto: null,
      firmaRecepcionVacia: true,
      firmaRecepcionInicializada: false,

      enviandoFirmas: false,
      guardandoEvidenciaId: null,
    };
  },
  computed: {
     userToken() { return this.$store.state.user.token; },
    colspanTabla() {
      // 7 columnas base, +1 si mostramos selección
      if (!this.orden) return 7;
      return this.orden.status === 'en_proceso' ? 8 : 7;
    },
    detallesSeleccionados() {
      if (!this.orden || !Array.isArray(this.orden.detalles)) return [];
      return this.orden.detalles.filter((d) => d._seleccionado);
    },
    puedeProcederFirmas() {
      return (
        this.orden &&
        this.orden.status === 'en_proceso' &&
        this.detallesSeleccionados.length > 0 &&
        !this.bloquearSeleccion
      );
    },
    firmaEntregaSrc() {
        if (!this.orden || !this.orden.firma_entrega) return null;
        const raw = String(this.orden.firma_entrega || '').trim();
        if (!raw) return null;
        if (raw.startsWith('data:image')) return raw;
        return 'data:image/png;base64,' + raw;
    },

    // 👇 NUEVO: normaliza firma_recoleccion (o como la llames en tu API)
    firmaRecepcionSrc() {
        const firma = this.orden?.firma_recoleccion || this.orden?.firma_recepcion || null;
        if (!firma) return null;
        const raw = String(firma || '').trim();
        if (!raw) return null;
        if (raw.startsWith('data:image')) return raw;
        return 'data:image/png;base64,' + raw;
    },
  },
  mounted() {
    this.cargarOrden();
  },
  methods: {
    normalizarDetalle(d) {
      return {
        ...d,
        _seleccionado: false,
        _evidencia_abierta: false,
        _evidencia_descripcion: d.descripcion_estado || '',
        _evidencia_observaciones: '',
        _evidencia_imagen_base64: '',
        _evidencia_imagen_nombre: '',
        _evidencia_preview: d.imagen_estado_url || '',
      };
    },
    async archivoABase64(file) {
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    toggleEvidenciaDetalle(det) {
      det._evidencia_abierta = !det._evidencia_abierta;
    },
    async onEvidenciaSeleccionada(det, event) {
      const file = event?.target?.files?.[0];
      if (!file) return;
      try {
        det._evidencia_imagen_base64 = await this.archivoABase64(file);
        det._evidencia_imagen_nombre = file.name || `unidad-${det.id_unidad}`;
        det._evidencia_preview = det._evidencia_imagen_base64;
      } catch (error) {
        console.error('Error al leer evidencia de entrega:', error);
        this.$toast?.error('No se pudo cargar la imagen seleccionada.');
      }
    },
    limpiarArchivoEvidencia(det) {
      det._evidencia_imagen_base64 = '';
      det._evidencia_imagen_nombre = '';
      det._evidencia_preview = det.imagen_estado_url || '';
      const ref = this.$refs['inputEvidenciaEntrega_' + det.id_detalle];
      const input = Array.isArray(ref) ? ref[0] : ref;
      if (input) input.value = '';
    },
    cancelarEvidenciaDetalle(det) {
      det._evidencia_abierta = false;
      det._evidencia_descripcion = det.descripcion_estado || '';
      det._evidencia_observaciones = '';
      this.limpiarArchivoEvidencia(det);
    },
    async guardarEvidenciaDetalle(det) {
      const descripcion = (det._evidencia_descripcion || '').trim();
      const observaciones = (det._evidencia_observaciones || '').trim();
      if (!descripcion && !det._evidencia_imagen_base64 && !observaciones) {
        this.$toast?.error('Agrega una descripción, una foto o una observación para guardar la evidencia.');
        return;
      }

      this.guardandoEvidenciaId = det.id_detalle;
      try {
        const payload = {
          id_orden: this.orden.id_orden,
          evidencias: [{
            id_detalle: det.id_detalle,
            id_unidad: det.id_unidad,
            descripcion_estado: descripcion,
            observaciones: observaciones,
            imagen_base64: det._evidencia_imagen_base64 || null,
            imagen_nombre: det._evidencia_imagen_nombre || null,
          }],
        };

        const res = await axios.post('/api/almacen/ordenes-entrega/registrar-evidencia', payload);
        if (res.data?.status === 'ok') {
          this.$toast?.success('Evidencia de salida guardada correctamente.');
          await this.cargarOrden();
        } else {
          this.$toast?.error(res.data?.message || 'No se pudo guardar la evidencia.');
        }
      } catch (error) {
        console.error('Error al guardar evidencia de entrega:', error);
        this.$toast?.error(error.response?.data?.message || 'Error al guardar la evidencia de salida.');
      } finally {
        this.guardandoEvidenciaId = null;
      }
    },
    async aprobarAjuste() {
    if (!this.orden) return;
    try {
      const res = await axios.post('/api/almacen/ordenes-entrega/ajustes/aprobar', {
        id_orden: this.orden.id_orden,
        tokenUser: this.userToken,
      });

      if (res.data?.status === 'ok') {
        this.$toast?.success('Ajuste aprobado. La orden ahora puede ser editada.');
        await this.cargarOrden(); // recarga para ver status=pendiente y versión actual
      } else {
        this.$toast?.error(res.data?.message || 'No se pudo aprobar el ajuste.');
      }
    } catch (error) {
      console.error('Error al aprobar ajuste:', error);
      this.$toast?.error('Error al aprobar el ajuste.');
    }
  },

  async rechazarAjuste() {
    if (!this.orden) return;
    try {
      const res = await axios.post('/api/almacen/ordenes-entrega/ajustes/rechazar', {
        id_orden: this.orden.id_orden,
        tokenUser: this.userToken,
      });

      if (res.data?.status === 'ok') {
        this.$toast?.success('Solicitud de ajuste rechazada. La orden vuelve a estar en proceso.');
        await this.cargarOrden();
      } else {
        this.$toast?.error(res.data?.message || 'No se pudo rechazar el ajuste.');
      }
    } catch (error) {
      console.error('Error al rechazar ajuste:', error);
      this.$toast?.error('Error al rechazar el ajuste.');
    }
  },
    async cargarOrden() {
      const id = this.$route.params.id;
      if (!id) return;

      this.cargando = true;
      try {
        const res = await axios.get(
          '/api/almacen/ordenes-entrega/ver/' + id
        );

        if (res.data?.status === 'ok' && res.data.orden) {
          // Nos aseguramos de que haya detalles como array
          const orden = res.data.orden;
          if (!Array.isArray(orden.detalles)) {
            orden.detalles = [];
          }
          // bandera de selección local
          orden.detalles = orden.detalles.map((d) => this.normalizarDetalle(d));
          this.orden = orden;
        } else {
          this.orden = null;
        }
      } catch (error) {
        console.error('Error al cargar detalle de orden de entrega:', error);
        this.$toast?.error(
          'No se pudo cargar el detalle de la orden de entrega.'
        );
        this.orden = null;
      } finally {
        this.cargando = false;
      }
    },

    // ---- Encabezado / helpers ----
    formatoFolio(folio, version = 1) {
        if (!folio && folio !== 0) return 'SIN FOLIO';
        const n = parseInt(folio, 10);
        if (Number.isNaN(n)) return folio;

        const base = 'ENT-' + String(n).padStart(4, '0');
        if (!version || version <= 1) {
            return base;
        }
        return `${base}-${version}`;
    },

    formatearFecha(f) {
      if (!f) return '—';
      const [y, m, d] = f.split('-');
      if (!y || !m || !d) return f;
      return `${d}/${m}/${y}`;
    },
    formatearFechaHora(fh) {
      if (!fh) return '—';
      const [fecha, hora] = fh.split(' ');
      if (!fecha) return fh;
      return this.formatearFecha(fecha) + (hora ? ` ${hora}` : '');
    },
    etiquetaStatus(status) {
      switch (status) {
        case 'pendiente':
          return 'Pendiente';
        case 'en_proceso':
          return 'En proceso';
        case 'finalizada':
          return 'Finalizada';
        case 'solicitando_ajuste':
          return 'Solicitando ajuste';
        default:
          return status || 'Pendiente';
      }
    },
    esEntregado(det) {
      const v = det?.entregado;
      return v === 1 || v === '1' || v === true;
    },
    esDevuelto(det) {
      const v = det?.devuelto;
      return v === 1 || v === '1' || v === true;
    },
    imprimir() {
      window.print();
    },
    volverListado() {
      this.$router.push({ name: 'DashboardOrdenesEntrega' });
    },

    // ---- Solicitud de ajuste ----
    toggleFormularioAjuste() {
      this.mostrandoFormularioAjuste = !this.mostrandoFormularioAjuste;
    },
    cancelarFormularioAjuste() {
      this.mostrandoFormularioAjuste = false;
      this.motivoAjuste = '';
    },
    async enviarSolicitudAjuste() {
      if (!this.orden || !this.orden.id_orden || !this.motivoAjuste) return;

      this.enviandoAjuste = true;
      try {
        const res = await axios.post(
          '/api/almacen/ordenes-entrega/solicitar-ajuste',
          {
            id_orden: this.orden.id_orden,
            motivo: this.motivoAjuste,
            tokenUser: this.userToken,
          }
        );

        if (res.data?.status === 'ok') {
          this.$toast?.success('Solicitud de ajuste enviada.');
          await this.cargarOrden(); // recarga estado y motivo
          this.motivoAjuste = '';
          this.mostrandoFormularioAjuste = false;
        } else {
          this.$toast?.error(
            res.data?.message || 'No se pudo enviar la solicitud de ajuste.'
          );
        }
      } catch (error) {
        console.error('Error al solicitar ajuste:', error);
        this.$toast?.error('Error al enviar la solicitud de ajuste.');
      } finally {
        this.enviandoAjuste = false;
      }
    },

    // ---- Selección de detalles ----
    toggleSeleccionDetalle(det) {
      if (this.bloquearSeleccion) return;
      det._seleccionado = !det._seleccionado;
    },

    // ---- Flujo de firmas ----
    iniciarFlujoFirmas() {
      if (!this.detallesSeleccionados.length) {
        this.$toast?.error('Selecciona al menos una unidad para entregar.');
        return;
      }

      this.bloquearSeleccion = true;
      this.resumenSeleccion = this.detallesSeleccionados.map((d) => ({ ...d }));
      this.mostrandoModalFirmas = true;
      this.pasoFirma = 1;
      this.firmaRecepcionInicializada = false;

      this.$nextTick(() => {
        this.inicializarCanvas('entrega');
        // no inicializamos recepción todavía
      });
    },

    cancelarFlujoFirmas() {
      this.mostrandoModalFirmas = false;
      this.bloquearSeleccion = false;
      this.resumenSeleccion = [];
      this.limpiarFirma('entrega');
      this.limpiarFirma('recepcion');
      this.firmaRecepcionInicializada = false;
    },

    irAPasoRecepcion() {
      this.pasoFirma = 2;

      this.$nextTick(() => {
        if (!this.firmaRecepcionInicializada) {
          this.inicializarCanvas('recepcion');
        }
      });
    },

    inicializarCanvas(tipo) {
      const refName = tipo === 'entrega' ? 'canvasEntrega' : 'canvasRecepcion';
      const canvas = this.$refs[refName];
      if (!canvas) return;

      const ctx = canvas.getContext('2d');

      // Fondo oscuro
    //   ctx.fillStyle = '#000000';
    //   ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Trazo blanco
      ctx.strokeStyle = '#ffffff';
      ctx.lineWidth = 2;
      ctx.lineJoin = 'round';
      ctx.lineCap = 'round';

      if (tipo === 'entrega') {
        this.firmaEntregaVacia = true;
      } else {
        this.firmaRecepcionVacia = true;
        this.firmaRecepcionInicializada = true;
      }
    },

    obtenerPosicionEnCanvas(evt, canvas) {
      const rect = canvas.getBoundingClientRect();
      let clientX;
      let clientY;

      if (evt.touches && evt.touches.length > 0) {
        clientX = evt.touches[0].clientX;
        clientY = evt.touches[0].clientY;
      } else if (evt.changedTouches && evt.changedTouches.length > 0) {
        clientX = evt.changedTouches[0].clientX;
        clientY = evt.changedTouches[0].clientY;
      } else {
        clientX = evt.clientX;
        clientY = evt.clientY;
      }

      return {
        x: clientX - rect.left,
        y: clientY - rect.top,
      };
    },

    inicioDibujo(tipo, evt) {
      const refName = tipo === 'entrega' ? 'canvasEntrega' : 'canvasRecepcion';
      const canvas = this.$refs[refName];
      if (!canvas) return;

      const pos = this.obtenerPosicionEnCanvas(evt, canvas);
      if (!pos) return;

      if (tipo === 'entrega') {
        this.firmaEntregaDibujando = true;
        this.firmaEntregaUltimoPunto = pos;
      } else {
        this.firmaRecepcionDibujando = true;
        this.firmaRecepcionUltimoPunto = pos;
      }
    },

    dibujar(tipo, evt) {
      const refName = tipo === 'entrega' ? 'canvasEntrega' : 'canvasRecepcion';
      const canvas = this.$refs[refName];
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      const pos = this.obtenerPosicionEnCanvas(evt, canvas);
      if (!pos) return;

      if (tipo === 'entrega') {
        if (!this.firmaEntregaDibujando || !this.firmaEntregaUltimoPunto) return;
        ctx.beginPath();
        ctx.moveTo(this.firmaEntregaUltimoPunto.x, this.firmaEntregaUltimoPunto.y);
        ctx.lineTo(pos.x, pos.y);
        ctx.stroke();
        this.firmaEntregaUltimoPunto = pos;
        this.firmaEntregaVacia = false;
      } else {
        if (!this.firmaRecepcionDibujando || !this.firmaRecepcionUltimoPunto) return;
        ctx.beginPath();
        ctx.moveTo(
          this.firmaRecepcionUltimoPunto.x,
          this.firmaRecepcionUltimoPunto.y
        );
        ctx.lineTo(pos.x, pos.y);
        ctx.stroke();
        this.firmaRecepcionUltimoPunto = pos;
        this.firmaRecepcionVacia = false;
      }
    },

    finDibujo(tipo) {
      if (tipo === 'entrega') {
        this.firmaEntregaDibujando = false;
        this.firmaEntregaUltimoPunto = null;
      } else {
        this.firmaRecepcionDibujando = false;
        this.firmaRecepcionUltimoPunto = null;
      }
    },

    limpiarFirma(tipo) {
      const refName = tipo === 'entrega' ? 'canvasEntrega' : 'canvasRecepcion';
      const canvas = this.$refs[refName];
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.inicializarCanvas(tipo);
    },

    obtenerDataURLFirma(tipo) {
        const refName = tipo === 'entrega' ? 'canvasEntrega' : 'canvasRecepcion';
        const canvas = this.$refs[refName];
        if (!canvas) return null;

        // Clonamos el canvas a uno offscreen
        const offCanvas = document.createElement('canvas');
        offCanvas.width = canvas.width;
        offCanvas.height = canvas.height;
        const offCtx = offCanvas.getContext('2d');

        // Dibujamos la firma tal cual está (línea blanca sobre transparente)
        offCtx.drawImage(canvas, 0, 0);

        // Leemos pixeles y convertimos blanco => negro, manteniendo alpha
        const imgData = offCtx.getImageData(0, 0, offCanvas.width, offCanvas.height);
        const data = imgData.data;

        for (let i = 0; i < data.length; i += 4) {
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const a = data[i + 3];

            // Si el pixel tiene alpha y es "claro" (la línea blanca)
            if (a !== 0 && (r > 200 && g > 200 && b > 200)) {
            data[i] = 0;     // R
            data[i + 1] = 0; // G
            data[i + 2] = 0; // B
            // a (alpha) se queda igual
            }
        }

        offCtx.putImageData(imgData, 0, 0);

        // Devolvemos la firma ya con trazo negro y fondo transparente
        return offCanvas.toDataURL('image/png');
    },


    async confirmarFirmas() {
      if (!this.orden || !this.orden.id_orden) return;
      if (!this.detallesSeleccionados.length) return;

      const firmaEntrega = this.obtenerDataURLFirma('entrega');
      const firmaRecepcion = this.obtenerDataURLFirma('recepcion');

      if (
        this.firmaEntregaVacia ||
        this.firmaRecepcionVacia ||
        !firmaEntrega ||
        !firmaRecepcion
      ) {
        this.$toast?.error('Ambas firmas son obligatorias.');
        return;
      }

      this.enviandoFirmas = true;

      try {
        const payload = {
          id_orden: this.orden.id_orden,
          detalles: this.detallesSeleccionados.map((d) => d.id_detalle),
          firma_entrega: firmaEntrega,
          firma_recepcion: firmaRecepcion,
        };

        const res = await axios.post(
          '/api/almacen/ordenes-entrega/firmar-entrega',
          payload
        );

        if (res.data?.status === 'ok') {
          this.$toast?.success('Orden finalizada y firmas registradas.');
          this.mostrandoModalFirmas = false;
          this.bloquearSeleccion = false;
          this.resumenSeleccion = [];
          await this.cargarOrden();
        } else {
          this.$toast?.error(
            res.data?.message || 'No se pudo guardar la entrega.'
          );
        }
      } catch (error) {
        console.error('Error al confirmar firmas:', error);
        this.$toast?.error('Error al confirmar la entrega.');
      } finally {
        this.enviandoFirmas = false;
      }
    },
  },
};
</script>


<style scoped>
.almacen-page {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1.5rem 1rem;
}

.almacen-wrapper {
  width: 100%;
  max-width: 1100px;
}

.almacen-card {
  border-radius: 1.4rem;
  padding: 1.2rem 1.1rem 1rem;
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.35),
      rgba(15, 23, 42, 0.96)
    );
  backdrop-filter: blur(22px);
  border: 1px solid rgba(148, 163, 184, 0.6);
  box-shadow:
    0 16px 40px rgba(15, 23, 42, 0.9),
    0 0 0 1px rgba(15, 23, 42, 0.85);
}

.almacen-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #e5e7eb;
}

.almacen-subtitle {
  font-size: 0.78rem;
  color: #94a3b8;
}

.entrada-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.9rem;
}

.entrada-header__actions {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.entrada-hint {
  font-size: 0.8rem;
  color: #94a3b8;
}

/* Banner ajuste */
.ajuste-banner {
  border-radius: 0.8rem;
  border: 1px solid rgba(248, 250, 252, 0.4);
  background: linear-gradient(
    135deg,
    rgba(248, 250, 252, 0.08),
    rgba(15, 23, 42, 0.96)
  );
  padding: 0.5rem 0.7rem;
  margin-bottom: 0.45rem;
  display: flex;
  justify-content: space-between;
  gap: 0.7rem;
}

.ajuste-banner-body {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.ajuste-banner-title {
  font-size: 0.8rem;
  font-weight: 600;
  color: #fbbf24;
}

.ajuste-banner-text {
  font-size: 0.76rem;
  color: #e5e7eb;
}

.ajuste-banner-actions {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.ajuste-btn-mini {
  font-size: 0.7rem;
  padding: 0.25rem 0.7rem;
}

/* Barra acciones en proceso */
.orden-acciones-bar {
  border-radius: 0.8rem;
  border: 1px solid rgba(148, 163, 184, 0.6);
  background: rgba(15, 23, 42, 0.95);
  padding: 0.4rem 0.6rem;
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
  gap: 0.7rem;
  align-items: center;
}

.orden-acciones-info {
  font-size: 0.75rem;
  color: #cbd5f5;
}

.orden-acciones-buttons {
  display: flex;
  gap: 0.4rem;
}

/* Panel ajuste */
.ajuste-panel {
  border-radius: 0.8rem;
  border: 1px solid rgba(148, 163, 184, 0.7);
  background: rgba(15, 23, 42, 0.98);
  padding: 0.5rem 0.6rem;
  margin-bottom: 0.55rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.ajuste-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ajuste-panel-close {
  background: transparent;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  font-size: 0.8rem;
}

.ajuste-textarea {
  width: 100%;
  border-radius: 0.75rem;
  border: 1px solid rgba(148, 163, 184, 0.7);
  background: rgba(15, 23, 42, 0.98);
  color: #e5e7eb;
  font-size: 0.78rem;
  padding: 0.45rem 0.55rem;
  resize: vertical;
}

.ajuste-textarea::placeholder {
  color: #64748b;
}

.ajuste-panel-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.4rem;
}

/* Contenedor detalle */
.orden-detalle {
  border-radius: 1rem;
  border: 1px solid rgba(148, 163, 184, 0.55);
  background: rgba(15, 23, 42, 0.96);
  padding: 0.7rem 0.7rem 0.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  font-size: 0.78rem;
  color: #e5e7eb;
}

/* Encabezado tipo ficha */
.orden-header-simple {
  display: grid;
  grid-template-columns: 1.1fr 1.3fr 1.1fr;
  gap: 0.6rem;
  border-bottom: 1px solid rgba(148, 163, 184, 0.45);
  padding-bottom: 0.35rem;
}

.orden-header-col {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.orden-header-row {
  display: grid;
  grid-template-columns: 130px 1fr;
  gap: 0.25rem;
}

.orden-header-label {
  font-weight: 500;
  color: #cbd5f5;
}

.orden-header-value {
  color: #e5e7eb;
  word-break: break-word;
}

.orden-header-strong {
  font-size: 0.86rem;
}

.orden-comentarios-simple {
  display: grid;
  grid-template-columns: 130px 1fr;
  gap: 0.25rem;
}

/* Tabla */
.orden-items-table {
  margin-top: 0.3rem;
}

.orden-items-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.76rem;
}

.orden-items-table th,
.orden-items-table td {
  border: 1px solid rgba(148, 163, 184, 0.6);
  padding: 0.16rem 0.3rem;
  vertical-align: top;
}

.orden-items-table th {
  text-align: left;
  font-weight: 600;
  background: rgba(15, 23, 42, 0.96);
}

.orden-items-table-center {
  text-align: center;
}

.orden-items-table-empty {
  text-align: center;
  font-style: italic;
  color: #94a3b8;
}

.orden-checkbox {
  width: 14px;
  height: 14px;
}

/* Firmas (parte visual) */
.orden-firmas {
  margin-top: 0.4rem;
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
}

.orden-firma-col {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
}

.orden-firma-linea {
  width: 100%;
  border-bottom: 1px solid rgba(148, 163, 184, 0.9);
  margin-top: 1.2rem;
}

.orden-firma-label {
  font-size: 0.76rem;
  text-align: center;
}
.orden-firma-img-wrapper {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  border-bottom: 1px solid rgba(148, 163, 184, 0.9);
}

.orden-firma-img {
  max-width: 100%;
  max-height: 70px;
  object-fit: contain;
  display: block;
}

/* Botones iOS */
.ios-primary-button,
.ios-ghost-button {
  border-radius: 999px;
  padding: 0.42rem 0.9rem;
  font-size: 0.78rem;
  border: 1px solid transparent;
  cursor: pointer;
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    transform 0.08s ease,
    box-shadow 0.16s ease;
}

.ios-primary-button {
  background: radial-gradient(
    circle at 0 0,
    rgba(129, 140, 248, 0.7),
    rgba(37, 99, 235, 1)
  );
  border-color: rgba(129, 140, 248, 0.9);
  color: #e5e7eb;
  box-shadow: 0 12px 26px rgba(37, 99, 235, 0.7);
}

.ios-primary-button:hover {
  transform: translateY(-0.5px);
  box-shadow: 0 16px 32px rgba(37, 99, 235, 0.9);
}

.ios-ghost-button {
  background: rgba(15, 23, 42, 0.9);
  border-color: rgba(148, 163, 184, 0.7);
  color: #e5e7eb;
}

.ios-ghost-button:hover {
  background: rgba(15, 23, 42, 1);
}

/* Modal firmas */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 40;
}

.modal-card {
  width: 100%;
  max-width: 820px;
  border-radius: 1.2rem;
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.35),
      rgba(15, 23, 42, 0.98)
    );
  border: 1px solid rgba(148, 163, 184, 0.8);
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.95);
  padding: 1rem 1.1rem 0.9rem;
  color: #e5e7eb;
}

.modal-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.3rem;
}

.modal-text {
  font-size: 0.78rem;
  color: #cbd5f5;
  margin-bottom: 0.6rem;
}

.firma-wrapper {
  border-radius: 0.9rem;
  border: 1px solid rgba(148, 163, 184, 0.8);
  background: rgba(15, 23, 42, 0.98);
  padding: 0.35rem;
}

.firma-wrapper--top {
  margin-top: 0.6rem;
}

.firma-canvas {
  width: 100%;
  display: block;
  border-radius: 0.75rem;
}

.modal-actions {
  margin-top: 0.7rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-actions-right {
  display: flex;
  gap: 0.4rem;
}

/* Resumen tabla */
.resumen-tabla {
  margin-top: 0.4rem;
  border-radius: 0.75rem;
  border: 1px solid rgba(148, 163, 184, 0.7);
  overflow: hidden;
}

.resumen-tabla table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.75rem;
}

.resumen-tabla th,
.resumen-tabla td {
  border-bottom: 1px solid rgba(30, 64, 175, 0.6);
  padding: 0.25rem 0.35rem;
}

.resumen-tabla thead th {
  background: rgba(15, 23, 42, 0.96);
  font-weight: 600;
}

/* Responsive */
@media (max-width: 900px) {
  .orden-header-simple {
    grid-template-columns: 1fr;
  }

  .orden-header-row,
  .orden-comentarios-simple {
    grid-template-columns: 120px 1fr;
  }

  /* Ya no tocamos .orden-firmas: se queda en fila también en móvil */

  .entrada-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .orden-acciones-bar {
    flex-direction: column;
    align-items: flex-start;
  }

  .modal-card {
    margin: 0 0.8rem;
  }
}

.orden-firma-img-wrapper{
filter: invert(1);
}
/* Ajustes para impresión */
/* Ajustes para impresión */
@media print {
  .no-print {
    display: none !important;
  }

  .almacen-page {
    padding: 0;
  }

  .almacen-card {
    background: #ffffff !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    border: 1px solid #000000 !important;
  }

  .orden-detalle {
    background: #ffffff !important;
    color: #000000 !important;
  }

  .orden-items-table th,
  .orden-items-table td {
    border-color: #000000 !important;
  }

  /* 🔹 Forzar encabezado a 3 columnas también en impresión */
  .orden-header-simple {
    display: grid !important;
    grid-template-columns: 1.1fr 1.3fr 1.1fr !important;
    gap: 0.4rem;
    border-bottom: 1px solid #000000 !important;
    padding-bottom: 0.3rem;
  }

  .orden-header-row,
  .orden-comentarios-simple {
    grid-template-columns: 110px 1fr !important;
    font-size: 0.7rem;
  }

  .orden-header-label {
    font-size: 0.7rem;
    color: #000000 !important;
  }

  .orden-header-value {
    font-size: 0.7rem;
    color: #000000 !important;
  }

  .orden-header-strong {
    font-size: 0.78rem;
  }

  /* Forzamos que las firmas salgan en fila también en la impresión */
  .orden-firmas {
    flex-direction: row !important;
  }

  /* Fondo claro y sin invert en impresión */
  .orden-firma-img-wrapper {
    background: #ffffff !important;
    border-bottom: 1px solid #000000 !important;
    filter: none !important;
  }
}


.orden-evidencias-panel {
  margin-top: 1rem;
  padding: 1rem;
  border-radius: 1rem;
  border: 1px solid rgba(148, 163, 184, 0.22);
  background: rgba(15, 23, 42, 0.34);
}

.orden-evidencias-panel__head h3 {
  margin: 0;
  font-size: 1rem;
  color: #e5e7eb;
}

.orden-evidencias-panel__head p {
  margin: 0.35rem 0 0;
  color: #94a3b8;
  font-size: 0.84rem;
}

.orden-evidencias-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 0.9rem;
  margin-top: 1rem;
}

.orden-evidencia-card {
  border-radius: 1rem;
  border: 1px solid rgba(148, 163, 184, 0.18);
  background: rgba(15, 23, 42, 0.46);
  padding: 0.9rem;
}

.orden-evidencia-card__top {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  align-items: flex-start;
}

.orden-evidencia-card__title {
  color: #f8fafc;
  font-weight: 600;
}

.orden-evidencia-card__meta {
  color: #94a3b8;
  font-size: 0.8rem;
  margin-top: 0.25rem;
}

.evidencia-btn-mini {
  padding: 0.45rem 0.75rem;
  font-size: 0.78rem;
}

.orden-evidencia-actual {
  display: grid;
  grid-template-columns: 82px 1fr;
  gap: 0.75rem;
  margin-top: 0.85rem;
}

.orden-evidencia-actual__media {
  width: 82px;
  height: 82px;
  border-radius: 0.85rem;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.22);
  background: rgba(2, 6, 23, 0.55);
}

.orden-evidencia-actual__media img,
.orden-evidencia-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.orden-evidencia-chip-row {
  display: flex;
  gap: 0.45rem;
  flex-wrap: wrap;
}

.orden-evidencia-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.5rem;
  border-radius: 999px;
  background: rgba(59, 130, 246, 0.16);
  color: #bfdbfe;
  font-size: 0.72rem;
}

.orden-evidencia-chip--soft {
  background: rgba(148, 163, 184, 0.16);
  color: #cbd5e1;
}

.orden-evidencia-chip--muted {
  background: rgba(71, 85, 105, 0.22);
  color: #94a3b8;
}

.orden-evidencia-actual__text {
  margin: 0.55rem 0 0;
  color: #e2e8f0;
  font-size: 0.84rem;
  line-height: 1.45;
}

.orden-evidencia-form {
  margin-top: 0.9rem;
  display: grid;
  gap: 0.7rem;
}

.ajuste-textarea--small {
  min-height: 72px;
}

.orden-evidencia-form__file-row {
  display: flex;
  gap: 0.6rem;
  align-items: center;
  flex-wrap: wrap;
}

.orden-evidencia-input-file {
  max-width: 100%;
  color: #cbd5e1;
}

.orden-evidencia-preview {
  width: 150px;
  height: 150px;
  overflow: hidden;
  border-radius: 0.9rem;
  border: 1px solid rgba(148, 163, 184, 0.22);
}

@media (max-width: 720px) {
  .orden-evidencia-card__top,
  .orden-evidencia-form__file-row {
    flex-direction: column;
    align-items: stretch;
  }

  .orden-evidencia-actual {
    grid-template-columns: 1fr;
  }

  .orden-evidencia-actual__media,
  .orden-evidencia-preview {
    width: 100%;
    height: 180px;
  }
}

</style>
